export type LockAttempt<T> =
  | { acquired: true; value: T }
  | { acquired: false }

const lockManager = (): LockManager | null =>
  typeof navigator !== 'undefined' && navigator.locks
    ? navigator.locks
    : null

/** Exclusive across tabs; falls back to the caller's in-process mutex. */
export const withCrossTabLock = async <T>(
  name: string,
  task: () => Promise<T>,
): Promise<T> => {
  const locks = lockManager()
  if (!locks) return task()
  return locks.request(name, task)
}

/** Try once; useful for schedulers where another tab already doing work wins. */
export const tryCrossTabLock = async <T>(
  name: string,
  task: () => Promise<T>,
): Promise<LockAttempt<T>> => {
  const locks = lockManager()
  if (!locks) return { acquired: true, value: await task() }
  return locks.request(name, { ifAvailable: true }, async (lock) =>
    lock
      ? { acquired: true as const, value: await task() }
      : { acquired: false as const },
  )
}
